import { MessageCircle, Phone, Check } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";

const HERO_VIDEO = "/assets/images/hero-video.mp4";

const HeroSection = ({ scrollToContact, onOpenWhatsApp }) => {
  const { t } = useLanguage();

  return (
    <section className="relative min-h-screen" data-testid="hero-section">
      {/* Video background */}
      <video
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        className="absolute inset-0 w-full h-full object-cover"
      >
        <source src={HERO_VIDEO} type="video/mp4" />
      </video>

      <div className="absolute inset-0 bg-black/60" />
      <div className="relative z-10 min-h-screen flex flex-col justify-end pb-16 md:pb-24 px-4 md:px-8 lg:px-16 max-w-7xl mx-auto">
        <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-medium text-white leading-tight mb-3 max-w-4xl animate-fade-in-up" data-testid="hero-h1">
          {t.hero.h1}
        </h1>
        <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-normal text-white/85 leading-snug mb-6 max-w-3xl animate-fade-in-up stagger-1" data-testid="hero-title">
          {t.hero.title}
        </h2>
        <p className="text-base md:text-lg text-white/90 max-w-3xl mb-8 leading-relaxed animate-fade-in-up stagger-2" data-testid="hero-subtitle">
          {t.hero.subtitle}
        </p>
        <ul className="space-y-3 mb-8 animate-fade-in-up stagger-3">
          {t.hero.points.map((point, index) => (
            <li key={index} className="flex items-start gap-3 text-white">
              <Check className="w-5 h-5 text-[#D4A03D] flex-shrink-0 mt-0.5" />
              <span className="text-sm md:text-base">{point}</span>
            </li>
          ))}
        </ul>
        <div className="flex flex-col sm:flex-row gap-4 animate-fade-in-up stagger-4">
          <button onClick={onOpenWhatsApp} data-testid="hero-whatsapp-cta" className="inline-flex items-center justify-center gap-3 bg-[#B5613B] hover:bg-[#8a4a2d] text-white px-8 py-4 uppercase tracking-widest text-sm font-medium transition-all duration-300 hover:scale-105 shadow-lg shadow-black/30">
            <MessageCircle className="w-5 h-5" />
            {t.hero.ctaWhatsApp}
          </button>
          <button onClick={scrollToContact} data-testid="hero-call-cta" className="inline-flex items-center justify-center gap-3 bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#B5613B] px-8 py-4 uppercase tracking-widest text-sm font-medium transition-all duration-300">
            <Phone className="w-5 h-5" />
            {t.hero.ctaCall}
          </button>
        </div>
      </div>
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce hidden md:block">
        <div className="w-6 h-10 rounded-full border-2 border-white/50 flex items-start justify-center pt-2">
          <div className="w-1.5 h-3 bg-white rounded-full animate-pulse" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
